import { render, staticRenderFns } from "./RouteBreadcrumb.vue?vue&type=template&id=6ff1df30&scoped=true"
import script from "./RouteBreadcrumb.vue?vue&type=script&lang=js"
export * from "./RouteBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff1df30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ff1df30')) {
      api.createRecord('6ff1df30', component.options)
    } else {
      api.reload('6ff1df30', component.options)
    }
    module.hot.accept("./RouteBreadcrumb.vue?vue&type=template&id=6ff1df30&scoped=true", function () {
      api.rerender('6ff1df30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Breadcrumb/RouteBreadcrumb.vue"
export default component.exports